// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e61c0340","845":"d63fb6e6"}[chunkId] + ".chunk.js";
};